import { BookmarkRepository } from '@/domain/repositories/bookmark/bookmarkRepository'
import { Bookmark } from '@/domain/value_objects/bookmark/bookmark'

export class BookmarkUseCase {
  constructor(private repository: BookmarkRepository) {}

  async getBookmark(userId: string): Promise<Bookmark> {
    try {
      return await this.repository.getBookmark(userId)
    } catch (error) {
      console.error(`Error in BookmarkUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async postBookmark(problemId: string, userId: string): Promise<void> {
    try {
      await this.repository.postBookmark(problemId, userId)
    } catch (error) {
      console.error(`Error in BookmarkUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async deleteBookmark(problemId: string, userId: string): Promise<void> {
    try {
      await this.repository.deleteBookmark(problemId, userId)
    } catch (error) {
      console.error(`Error in BookmarkUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
